import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "input"];

  guard(event) {
    if (this.submitting) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.submitting = true;
    this.setDisabled(true);
  }

  submitEnded(event) {
    if (!event.detail.success) {
      this.submitting = false;
      this.setDisabled(false);
    }
  }

  setDisabled(disabled) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = disabled;
    if (this.hasInputTarget) this.inputTarget.readOnly = disabled;
  }
}
